import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  UnlinkAccountRequest,
  UnlinkAccountResponse,
} from '../sso/sso_pb';

import {
  SsoManager as __SsoManager,
} from '../sso/sso_pb_service';

@Injectable({providedIn: 'root'})
export class SsoManager {

  constructor(private _ngZone: NgZone) {
  }

  unlinkAccount(request: UnlinkAccountRequest): Promise<UnlinkAccountResponse>;
  unlinkAccount(request: UnlinkAccountRequest, metadata: grpc.Metadata): Promise<UnlinkAccountResponse>;
  unlinkAccount(request: UnlinkAccountRequest, callback: (err: any|null, response: UnlinkAccountResponse, metadata: grpc.Metadata) => void): void;
  unlinkAccount(request: UnlinkAccountRequest, metadata: grpc.Metadata, callback: (err: any|null, response: UnlinkAccountResponse, metadata: grpc.Metadata) => void): void;

  unlinkAccount(request: UnlinkAccountRequest, arg1?: grpc.Metadata|((err: any|null, response: UnlinkAccountResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: UnlinkAccountResponse, metadata: grpc.Metadata) => void): Promise<UnlinkAccountResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<UnlinkAccountResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__SsoManager.UnlinkAccount, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

